import { Route, Routes } from "react-router-dom";
import Home from "./Home/Home";

import 'aos/dist/aos.css';
import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin"; 
import { TextPlugin } from "gsap/TextPlugin";

export default function App() {
    useEffect(() => {
        // Register GSAP plugins
        gsap.registerPlugin(ScrambleTextPlugin);
        gsap.registerPlugin(TextPlugin);
    }, []);
    
    return <>
        <Routes>
            <Route path="/" element={<Home />} />
        </Routes>
    </>
}
